const { VUE_APP_API_DEV_BASE_URL: devURL, VUE_APP_API_PROD_BASE_URL: prodURL } = process.env

//! Api Base Set default Development
let apiBase = devURL
let subDomain = window.location.hostname?.split('.')?.[0]

//! If subdomain equal with production base, set to production url
if(subDomain === 'payment') apiBase = prodURL

export const baseURL = `${apiBase}/public/api/v1/acc/`